import React from 'react'
import styles from './Skeleton.module.css'

export const SkeletonTaskCard = () => (
  <div className={styles.taskCard} aria-hidden>
    <div className={`${styles.block} ${styles.checkbox}`} />
    <div className={styles.textCol}>
      <div className={`${styles.block} ${styles.line}`} />
      <div className={`${styles.block} ${styles.line} ${styles.lineShort}`} />
    </div>
    <div className={styles.actions}>
      <div className={`${styles.block} ${styles.actionPill}`} />
      <div className={`${styles.block} ${styles.actionPill}`} />
    </div>
  </div>
)

export const SkeletonTaskList = ({ count = 4 }: { count?: number }) => (
  <div className={styles.list} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading tasks…</span>
    {Array.from({ length: count }, (_, i) => (
      <SkeletonTaskCard key={i} />
    ))}
  </div>
)

export const SkeletonHabitRow = () => (
  <div className={styles.habitRow} aria-hidden>
    <div className={`${styles.block} ${styles.iconBox}`} />
    <div className={styles.textCol}>
      <div className={`${styles.block} ${styles.line}`} />
      <div className={`${styles.block} ${styles.line} ${styles.lineShort}`} />
    </div>
    <div className={styles.actions}>
      <div className={`${styles.block} ${styles.actionPill}`} />
      <div className={`${styles.block} ${styles.actionPill}`} />
    </div>
  </div>
)

export const SkeletonHabitList = ({ count = 4 }: { count?: number }) => (
  <div className={styles.list} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading habits…</span>
    {Array.from({ length: count }, (_, i) => (
      <SkeletonHabitRow key={i} />
    ))}
  </div>
)

export const SkeletonBrainDumpSection = () => (
  <div className={styles.brainSection}>
    <div className={`${styles.block} ${styles.sectionTitle}`} />
    <SkeletonTaskList count={3} />
  </div>
)

export const SkeletonDashboardHeader = () => (
  <div className={styles.headerBar} aria-hidden>
    <div className={`${styles.block} ${styles.headerLine}`} style={{ width: 180 }} />
    <div className={`${styles.block} ${styles.headerLine} ${styles.headerLineWide}`} />
  </div>
)

export const SkeletonTaskDetailsMain = () => (
  <div className={styles.taskDetailsBlock} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading task…</span>
    <div className={styles.pillRow}>
      <div className={`${styles.block} ${styles.pill}`} />
      <div className={`${styles.block} ${styles.pill}`} style={{ width: 100 }} />
      <div className={`${styles.block} ${styles.pill}`} style={{ width: 40, borderRadius: 12 }} />
    </div>
    <div className={`${styles.block} ${styles.titleLine}`} />
    <div className={`${styles.block} ${styles.descBlock}`} />
    <SkeletonTaskList count={2} />
  </div>
)

export const SkeletonSidebarCards = () => (
  <div className={styles.sidebarStack} aria-hidden>
    <div className={`${styles.block} ${styles.sidebarCard}`} />
    <div className={`${styles.block} ${styles.sidebarCard}`} style={{ minHeight: 100 }} />
  </div>
)

const SkeletonWorkspaceFolderRow = ({ indent = 0 }: { indent?: number }) => (
  <div className={styles.workspaceFolderRow} style={{ paddingLeft: 10 + indent * 14 }} aria-hidden>
    <div className={`${styles.block} ${styles.workspaceRowIcon}`} />
    <div className={`${styles.block} ${styles.workspaceRowLine}`} />
  </div>
)

export const SkeletonWorkspaceFolderTree = () => (
  <div className={styles.workspaceList} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading folders…</span>
    <SkeletonWorkspaceFolderRow />
    <SkeletonWorkspaceFolderRow indent={1} />
    <SkeletonWorkspaceFolderRow indent={1} />
    <SkeletonWorkspaceFolderRow />
    <SkeletonWorkspaceFolderRow indent={1} />
  </div>
)

const SkeletonWorkspaceDocRow = () => (
  <div className={styles.workspaceDocRow} aria-hidden>
    <div className={`${styles.block} ${styles.workspaceDocIcon}`} />
    <div className={`${styles.block} ${styles.workspaceRowLine}`} />
  </div>
)

export const SkeletonWorkspaceDocList = ({ count = 4 }: { count?: number }) => (
  <div className={styles.workspaceList} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading documents…</span>
    {Array.from({ length: count }, (_, i) => (
      <SkeletonWorkspaceDocRow key={i} />
    ))}
  </div>
)

export const SkeletonWorkspaceEditor = () => (
  <div className={styles.workspaceEditorBlock} role="status" aria-live="polite">
    <span className={styles.visuallyHidden}>Loading document…</span>
    <div className={`${styles.block} ${styles.workspaceEditorTitle}`} />
    <div className={`${styles.block} ${styles.workspaceEditorPara}`} />
    <div className={`${styles.block} ${styles.workspaceEditorPara} ${styles.workspaceEditorParaShort}`} />
    <div className={`${styles.block} ${styles.workspaceEditorPara}`} />
  </div>
)
